module.exports = __webpack_public_path__ + "img/Sites in the future.a8fae539.png";